export type ViewportFramingProfile = {
  compact: boolean;
  portrait: boolean;
  fieldOfView: number;
  overviewDistanceScale: number;
  focusDistanceScale: number;
  focusLiftRatio: number;
  hitPaddingScale: number;
};

const DESKTOP_ASPECT = 16 / 9;

function clamp01(value: number) {
  return Math.max(0, Math.min(value, 1));
}

export function resolveViewportFraming(width: number, height: number, coarsePointer = false): ViewportFramingProfile {
  const safeWidth = Math.max(width, 1);
  const safeHeight = Math.max(height, 1);
  const aspect = safeWidth / safeHeight;
  const portraitPressure = clamp01((1.02 - aspect) / 0.58);
  const narrowPressure = clamp01((900 - safeWidth) / 540);
  const compactPressure = Math.max(portraitPressure, narrowPressure, coarsePointer ? 0.35 : 0);
  const desktopWidthRatio = DESKTOP_ASPECT / Math.max(aspect, 0.42);
  const widthFit = 1 + (Math.min(desktopWidthRatio, 2.3) - 1) * portraitPressure;

  return {
    compact: safeWidth <= 900 || coarsePointer,
    portrait: aspect < 0.92,
    fieldOfView: 60 + portraitPressure * 8,
    overviewDistanceScale: widthFit,
    focusDistanceScale: 1 + portraitPressure * 0.12,
    focusLiftRatio: portraitPressure * 0.16,
    hitPaddingScale: 1 + compactPressure * 0.7,
  };
}
